<template>
  <div class="market-insights-content container-fluid p-4 pt-11 pb-12">
    <div class="d-flex flex-column align-items-center mb-5">
      <div class="d-flex flex-column align-items-center">
        <h2 class="mb-1">{{ $t("market_insights.title") }}</h2>
      </div>
    </div>

    <!-- Market Reports Section -->
    <section class="mb-3 py-2">
      <h4 class="mb-3 font-serif text-body-emphasis">
        {{ $t("market_insights.sections.reports") }}
      </h4>
      <div class="row g-4">
        <ForwardOutlookCard />
        <ConsultingServicesCard />
      </div>
    </section>

    <!-- Charts Section -->
    <section class="mb-3 py-2">
      <h4 class="mb-3 font-serif text-body-emphasis">
        {{ $t("market_insights.sections.charts") }}
      </h4>
      <div class="row g-4">
        <CumulativeRELineChartCard />
        <NorwayReservoirLineChartCard :allZonesUnlocked />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useAccount } from "@/composables/account/useAccount";
import { isAdminAccount } from "@/composables/useAdminCheck";
import { useAccountFeatureFlags } from "@/composables/useAccountFeatureFlags";
import { computed } from "vue";
import ConsultingServicesCard from "./cards/ConsultingServicesCard.vue";
import CumulativeRELineChartCard from "./cards/CumulativeRELineChartCard.vue";
import ForwardOutlookCard from "./cards/ForwardOutlookCard.vue";
import NorwayReservoirLineChartCard from "./cards/NorwayReservoirLineChartCard.vue";

const { accountData } = useAccount();
const { hasFlag } = useAccountFeatureFlags(accountData);

const allZonesUnlocked = computed(() => {
  return (
    hasFlag("detailed_reservoir_levels_enabled").value ||
    isAdminAccount(accountData)
  );
});
</script>

<style scoped lang="scss">
.market-insights-content {
  background-color: var(--phoenix-body-bg);
  border-radius: 1rem 1rem 0 0;
  overflow-y: auto;
  height: 100%;
  min-height: 0; /* This is crucial for nested flex containers to allow scrolling */

  /* Prevent scroll propagation */
  overscroll-behavior: contain;
}
</style>
